import React from 'react';
import { parseMindMentions, type MindNodeHit, type MindSkill } from '@/utils/mindHost';
import { MindNodeIcon } from './mindNodeIcon';
import './mindMention.less';

function MentionChip({ hit }: { hit: MindNodeHit }): React.ReactElement {
  const label = hit.name || hit.id;
  return (
    <span className="mind-mention" title={label}>
      <MindNodeIcon type={hit.type} />
      <span className="mind-mention__label">@{label}</span>
    </span>
  );
}

function SkillChip({ skill }: { skill: MindSkill }): React.ReactElement {
  const label = skill.name || skill.id;
  return (
    <span className="mind-mention" title={label}>
      <span className="mind-mention__label">/{label}</span>
    </span>
  );
}

/** 用户气泡：接口里存的是 JSON，界面上文件显示 @名称，技能显示 /名称。 */
const MindMentionText: React.FC<{ text: string }> = ({ text }) => {
  const parts = parseMindMentions(text);
  return (
    <span className="msg-user-text">
      {parts.map((part, index) => {
        if (part.kind === 'text') return <span key={index}>{part.text}</span>;
        if (part.kind === 'mention') return <MentionChip key={index} hit={part.hit} />;
        return <SkillChip key={index} skill={part.skill} />;
      })}
    </span>
  );
};

export default MindMentionText;
